import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Loader from 'react-loader-spinner'
import ErrorBoundary from '../errorBoundary';
import toast from 'react-hot-toast';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  selectLoginData,
 } from '../login/loginSlice'

import {
 selectaccCheckerData,
 updateAccessionList,
 getSiteList,
 getDataAsync,
 getDataAsyncAmbra,
 clearaccCheckerData,
 updateSelectedSite,
 updateSelectedDate,
} from './accCheckerSlice';
import styles from './accChecker.module.css';
import DisplayTableDocPanel from './displayTableDocPanel';
import DisplayTableAmbra from './displayTableAmbra';
//import { updateEndDate } from '../sweeps/sweepsSlice';



export function AccChecker() {

  let { jwt } = useSelector(selectLoginData);
  let {accessionList, siteList,  Processing, selectedSite,accCheckerData, accCheckerDataAmbra, startDate, endDate, 
  }  = useSelector(selectaccCheckerData);
  
  const dispatch = useDispatch();
  let requestType = '';

  let displayStartDate = new Date(startDate);
  let displayEndDate = new Date(endDate);
  //let missingAccsFromBoth = [];

  
  const [dates, setDates] = useState({displayStartDate,displayEndDate})
  const [missingAccs,setMissingAccs] = useState({});

  const setMissingAccsFunction = (values) => {
    console.log('*****setMissingAccsFunction');
    console.log(values)
    console.log(JSON.stringify(values))
    //setMissingAccs(JSON.stringify(values))
    setMissingAccs(values)
  }

  const [showDocPanelList,setShowDocPanelListBtnClick] = useState(false);
  const [showAmbraList,setShowAmbraListBtnClick] = useState(false);
  const [showMissingAccsList,setShowMissingAccsListBtnClick] = useState(false);
  
  const showDocPanelListClicked = (showDocPanelList) => {
    setShowDocPanelListBtnClick(!showDocPanelList);
  }
  
  const showAmbraListClicked = (showAmbraList) => {
    setShowAmbraListBtnClick(!showAmbraList);
  }

  const showAccsMissingListClicked = (showMissingAccsList) => {
    setShowMissingAccsListBtnClick(!showMissingAccsList);
  }


   const getData = ((requestType) => {
    console.log('requestType = ' +requestType);
    console.log(selectedSite + ' is selected site')
    if (selectedSite === '') {
      toast.error('You need to selecte a slice')
      return;
    }
    dispatch(getDataAsync(accessionList,jwt,requestType,selectedSite))
  })

  const getSiteListData = ((requestType) => {
    console.log('requestType = ' +requestType);
    console.log(jwt);
    dispatch(getSiteList({jwt,requestType}));
  })


  const setNewDate = ((newDate, whichDate) => {
    let date = JSON.stringify(newDate);
    newDate = new Date(newDate);
    console.log('newdate is ' + newDate)
    newDate = date.slice(1,11);
    dispatch(updateSelectedDate({newDate,whichDate}));
    let displayStartDate = '';
    let displayEndDate = '';
    console.log('in set New Date')
    if (whichDate == 'start') {
      displayStartDate = new Date(newDate)//.toUTCString().split('T')[0];;
      displayEndDate = new Date(endDate)//.toUTCString().split('T')[0];;
    } 
    else if (whichDate == 'end') {
      displayEndDate = new Date(newDate)//.toUTCString().split('T')[0];;
      displayStartDate = new Date(endDate)//.toUTCString().split('T')[0];;
    
    }
    
    setDates({displayStartDate,displayEndDate});

  })

  

  useEffect(() => {
    //populate site list from docpanel  
    getSiteListData();
    },[])



  useEffect(() =>{
    console.log('acc data was returned')
    console.log('missing accs are ' + accCheckerData);
    console.log(typeof accCheckerData)
    if (typeof accCheckerData === 'object'
        && accCheckerData.length > 0
        && accCheckerData !== null
    ) {
      console.log(JSON.stringify(accCheckerData));
      let accessionReturned = accCheckerData.map((r,i) => r.AccNo);
      let accessionListTemp = accessionList.replace(/\n/g, "");
      let accessionAsArray = accessionListTemp.split(','); 
      let missingAccsTemp = accessionAsArray.filter(x => !accessionReturned.includes(x));
      console.log('missing accs')
      if (missingAccsTemp.length > 0) dispatch(getDataAsyncAmbra(missingAccsTemp,jwt,requestType,selectedSite))
      console.log('************');
      console.log(JSON.stringify(missingAccsTemp));
      setMissingAccsFunction(missingAccsTemp);
      //need to save missingAccs to State for later use
    }
    else {
      console.log('accCheckedData was empty so nothing to do');
    }


  },[accCheckerData])


  useEffect(() =>{
    console.log('acc data was returned')
    console.log('missing accs are ' + accCheckerData);
    console.log(typeof accCheckerData)
    if (typeof accCheckerData === 'object'
        && accCheckerData.length > 0
        && accCheckerData !== null
    ) {
      console.log(JSON.stringify(accCheckerData));
      let accessionReturned = accCheckerData.map((r,i) => r.AccNo);
      let accessionListTemp = accessionList.replace(/\n/g, "");
      let accessionAsArray = accessionListTemp.split(','); 
      let missingAccsTemp = accessionAsArray.filter(x => !accessionReturned.includes(x));
      console.log('missing accs from docpanel')
      //if (missingAccs.length > 0) dispatch(getDataAsyncAmbra(missingAccs,jwt,requestType,selectedSite))
      console.log(missingAccsTemp);
      console.log('now to find missing accs from docpanel and ambra');
      accessionReturned = accCheckerDataAmbra.map((r,i) => r.accession_number);
      console.log('accessionsReturnedAmbra is below');
      console.log(accessionReturned);
      accessionListTemp = accessionList.replace(/\n/g, "");
      accessionAsArray = accessionListTemp.split(','); 
      let missingAccsAmbra = accessionAsArray.filter(x => (!accessionReturned.includes(x)));
      missingAccsAmbra = missingAccsAmbra.filter(x => (missingAccsTemp.includes(x)));
      console.log('final missing accs');
      console.log(missingAccsAmbra);
      setMissingAccsFunction(missingAccsAmbra);
      
      
    }
    else {
      console.log('accCheckedData was empty so nothing to do');
    }


  },[accCheckerDataAmbra])




  

  let output = 
  Object.values(siteList).map((r , i) => 
    <option
      key={i}
      value={r.organisation_id}>
      {r.organisation_name}
    </option>
 )
 

  return (
    (siteList.length < 0) ? '' :
    <div>
      <div name='accessionValidation'><a href="/accessionValidation">accession Validator</a></div>
      <div className={styles.row}>
      <label  className={styles.descriptors}
          htmlFor="siteList">Select Site
        </label>
      <select id = 'siteList' 
      value = {selectedSite}
      onChange={e => dispatch(updateSelectedSite(e.target.value))}
      >
        <option 
          key = '0' 
          value = '0'
          >Select a Site</option>
        {output}
        
      </select>
      <DatePicker
      selected={dates.displayStartDate}
      //onSelect={handleDateSelect} //when day is clicked 
      onChange={e => setNewDate(e,'start')} //only when value has changed
      dateFormat="yyyy-MM-dd"
      />
      <DatePicker
      selected={dates.displayEndDate}
      //onSelect={handleDateSelect} //when day is clicked */
      onChange={e => setNewDate(e,'end')} //only when value has changed
      dateFormat="yyyy-MM-dd"
      />

        <label  className={styles.descriptors}
          htmlFor="accessionList">Enter Accession # List Here
        </label>
        <textarea
          id="accessionList"
          className={styles.accListField}
          aria-label="Accession # List"
          value={accessionList}
          type="textarea"
          onChange={e => dispatch(updateAccessionList(e.target.value))}
        >
        </textarea>
   
        
        <button
          className={styles.loginBtn}
          aria-label="fetchDataBtn"
          onClick={() => {getData('accList')}}
        >
     Validate
        </button>
        <button
          className={styles.loginBtn}
          aria-label="fetchDataBtn"
          onClick={() => {dispatch(clearaccCheckerData([]))}}
        >
      Clear
        </button>
      </div>
      <div className={styles.rowWhite}>
      {(Processing) ? <Loader 
         type="Puff"
         color="#00BFFF"
         height={100}
         width={100}
         //timeout={3000} //3 secs
      /> :   <ErrorBoundary>

      
            <button
            onClick={() => {showDocPanelListClicked(showDocPanelList)}}
            >
            Found in DocPanel : {accCheckerData.length}</button>
            <button
            onClick={() => {showAmbraListClicked(showAmbraList)}}
            >
              Found in Ambra : {accCheckerDataAmbra.length}</button>
            <button
            onClick={() => {showAccsMissingListClicked(showMissingAccsList)}}
            >
            Not Found in Neither: { missingAccs.length}</button>

            {(showDocPanelList === false) ? '' : <DisplayTableDocPanel />}
            {(showAmbraList === false) ? '' : <DisplayTableAmbra />}
            {(showMissingAccsList === false) ? 'false' : <textarea rows='30' cols='30'>{JSON.stringify(missingAccs)}</textarea>}
            
             </ErrorBoundary>
      }
       </div>
     </div>
  );
}
